import { toaster } from 'evergreen-ui';
import ModuleConfig from '../Config';
import Request from '../../../util/Api';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const Shop = ModuleConfig.Structures.Shop;
const ShopEmployee = ModuleConfig.Structures.ShopEmployee;
const CRUDActions = ModuleConfig.CRUDActions;

export function getShops(opts = { start: 0, limit: 20 }) {
    return CRUDActions.getAll(actions.getAll, {
        ...opts,
        endpoint: endpoints.shops,
        mapStructure: Shop,
        errorNotification: "Magazinele nu au putut fi încărcate"
    });
}

export function getShop(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.shop,
        mapStructure: Shop,
        errorNotification: "Magazinul nu a putut fi încărcat"
    });
}

export function createShop(values) {
    return CRUDActions.create(actions.create, {
        values,
        endpoint: endpoints.shops,
        mapStructure: Shop,
        successNotification: "Magazinul a fost creat",
        nextUrl: '/shops/'
    });
}

export function updateShop(id, values) {
    return CRUDActions.update(actions.edit, {
        id,
        values,
        endpoint: endpoints.shop,
        mapStructure: Shop,
        successNotification: "Magazinul a fost actualizat",
        nextUrl: '/shops/'
    });
}

export function deleteShop(id) {
    return CRUDActions.remove(actions.delete, {
        id,
        endpoint: endpoints.shop,
        successNotification: "Magazinul a fost șters",
        nextUrl: '/shops'
    });
}

// Employee management actions
export function getShopEmployees(shopId) {
    return async (dispatch) => {
        dispatch({ type: actions.getEmployees.request.id });

        try {
            const result = await Request.get(endpoints.employees, { id: shopId });
            const employees = result.data.map(item => new ShopEmployee(item));

            dispatch({ type: actions.getEmployees.success.id, options: employees });
        } catch (err) {
            console.error(err);
            dispatch({ type: actions.getEmployees.failure.id, options: err });
            toaster.danger("Angajații nu au putut fi încărcați");
        }
    };
}

export function addShopEmployee(shopId, values) {
    return async (dispatch) => {
        dispatch({ type: actions.addEmployee.request.id });

        try {
            const result = await Request.post(endpoints.employees, { id: shopId }, {}, values);
            const employee = new ShopEmployee(result.data);

            dispatch({ type: actions.addEmployee.success.id, options: employee });
            toaster.success("Angajatul a fost adăugat");
        } catch (err) {
            console.error(err);
            dispatch({ type: actions.addEmployee.failure.id, options: err });
            toaster.danger("Angajatul nu a putut fi adăugat");
        }
    };
}

export function updateShopEmployee(employeeId, values) {
    return async (dispatch) => {
        dispatch({ type: actions.updateEmployee.request.id });

        try {
            const result = await Request.put(endpoints.employee, { employeeId }, {}, values);
            const employee = new ShopEmployee(result.data);

            dispatch({ type: actions.updateEmployee.success.id, options: employee });
            toaster.success("Angajatul a fost actualizat");
        } catch (err) {
            console.error(err);
            dispatch({ type: actions.updateEmployee.failure.id, options: err });
            toaster.danger("Angajatul nu a putut fi actualizat");
        }
    };
}

export function removeShopEmployee(employeeId) {
    return async (dispatch) => {
        dispatch({ type: actions.removeEmployee.request.id });

        try {
            await Request.delete(endpoints.employee, { employeeId });

            dispatch({ type: actions.removeEmployee.success.id, options: { id: employeeId } });
            toaster.success("Angajatul a fost eliminat");
            
            // Note: Soft delete - employee is marked inactive but not removed from database
        } catch (err) {
            console.error('Remove employee error:', err);
            dispatch({ type: actions.removeEmployee.failure.id, options: err });
            toaster.danger(err?.message || "Angajatul nu a putut fi eliminat");
        }
    };
}
